import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-get-report',
  templateUrl: './get-report.component.html',
  styleUrls: ['./get-report.component.scss']
})
export class GetReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
